const DEFAULT_MIN_VERTICAL_LENGTH = 100
const DEFAULT_BOTTOM_PADDING = 10

export function buildSocialConnectionRoute({
	sourceNode,
	targetNode,
	familyLineOffsetY = 0,
	mostBottomLine = null,
	minVerticalLength = DEFAULT_MIN_VERTICAL_LENGTH,
	bottomPadding = DEFAULT_BOTTOM_PADDING,
} = {}) {
	if(!sourceNode || !targetNode){
		return null
	}

	let leftNode = sourceNode
	let rightNode = targetNode
	if(sourceNode.position().x > targetNode.position().x){
		leftNode = targetNode
		rightNode = sourceNode
	}

	let x1 = leftNode.position().x
	let y1 = leftNode.position().y + leftNode.height() / 2
	let x2 = rightNode.position().x
	let y2 = rightNode.position().y + rightNode.height() / 2
	let minVerticalLengthComputed = minVerticalLength + Number(familyLineOffsetY || 0)
	let yDiff = Math.abs(y1 - y2)
	let leftLength = minVerticalLengthComputed
	let rightLength = minVerticalLengthComputed

	if(y1 > y2){
		rightLength = minVerticalLengthComputed + yDiff
	} else {
		leftLength = minVerticalLengthComputed + yDiff
	}

	let baselineY = y1 + leftLength
	let lineY = Math.max(baselineY, Number(mostBottomLine || y1) + bottomPadding)

	return {
		startX: x1,
		startY: y1,
		endX: x2,
		endY: y2,
		lineY,
		segmentPoints: [x1, lineY, x2, lineY],
	}
}

export function getSocialConnectionSegments(edge) {
	if(!edge){
		return null
	}

	let segmentPoints = edge.segmentPoints?.() || []
	let [middleStartPoint] = segmentPoints
	let rs = edge._private?.rscratch
	if(!middleStartPoint || !rs){
		return null
	}

	let leftVerticalSegment = {
		x1: rs.startX,
		y1: rs.startY,
		x2: middleStartPoint.x,
		y2: middleStartPoint.y,
	}
	let middleHorizontalSegment = {
		x1: middleStartPoint.x,
		y1: middleStartPoint.y,
		x2: rs.endX,
		y2: middleStartPoint.y,
	}
	let rightVerticalSegment = {
		x1: rs.endX,
		y1: rs.endY,
		x2: rs.endX,
		y2: middleStartPoint.y,
	}

	return {
		leftVerticalSegment,
		middleHorizontalSegment,
		rightVerticalSegment,
		lineLength: middleHorizontalSegment.x2 - middleHorizontalSegment.x1,
	}
}

